import React from 'react'
import { LayoutDefaultProps } from './types'
import Main from '@components/Page/Main'

const LayoutDefault: React.FC <LayoutDefaultProps> = ({ children, name }) => {

    return(

        <>
            <Main name = {name}>{children}</Main>
        </>

    )

}

export default LayoutDefault